module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_aq_nor.ee2148dc.png";